import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';


@Injectable({
	providedIn: 'root'
})
export class EncuestaSatisfaccionService implements RequestCRUD<any, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	private _baseApi:string;

	constructor(
		private http: HttpClient,
		protected httpErrorHandler: HttpErrorHandler, 
		protected enviromentGlobalService: EnviromentGlobalService) 
	{
		this.API_URL = enviromentGlobalService.apiUrl;
		this._baseApi = `${this.API_URL}/EncuestaSatisfaccion`;
		this.handleError = httpErrorHandler.createHandleError('EncuestaSatisfaccion');
	}

	public get(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this._baseApi}?PageNumber=${entry.numeroPagina}&PageSize=12`, entry)
			.pipe(
				retry(2)
			);
	}

	public getById(id:number): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this._baseApi}/${id}`)
			.pipe(
				retry(2)
			);
	}

	public create(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this._baseApi}/Registrar`, entry)
			.pipe(
				retry(2)
			);
	}
	
	public update(entry: any): Observable<ResponseServiceModel> {
		return this.http.put<ResponseServiceModel>(`${this._baseApi}/${entry.id}`, entry)
			.pipe(
				retry(2)
			);
	}

	public delete(entry: any): Observable<ResponseServiceModel> {
		return this.http.delete<ResponseServiceModel>(`${this._baseApi}/${entry.id}`)
			.pipe(
				retry(2)
			);
	}
}